import { HTTPError } from 'ky';

export const extractServerMessage = async (error: unknown): Promise<string | null> => {
  if (!(error instanceof HTTPError)) {
    return null;
  }
  try {
    const body = (await error.response.clone().json()) as { message?: unknown };
    return typeof body.message === 'string' && body.message.trim().length > 0 ? body.message : null;
  } catch {
    return null;
  }
};
